<template>
 <van-empty image="error" description="抱歉，您暂无权限访问" />
</template>
<script>
  export default {
    mounted() {
      this.handleBack();
    },
    methods: {
      handleBack() {
        let options = {
            disabled: true,
            callback: function() {
              window.jme.browser.closeWeb()
            }
        }
        window.jme.browser.setGoBackDisabled(options)
      },
    }
  }
</script>